import { Link } from "@tanstack/react-router";

const env = import.meta.env as Record<string, string | undefined>;

const QUICK_LINKS = [
	{
		label: "Forms Builder",
		href: env.VITE_ATTORNEYS_BUILDER_URL ?? "http://localhost:3051",
	},
	{
		label: "Client Portals",
		href: env.VITE_CLIENTS_PORTALS_URL ?? "http://localhost:3052",
	},
	{
		label: "Superadmin",
		href: env.VITE_SUPERADMIN_URL ?? "http://localhost:3060",
	},
];

export default function Index() {
	return (
		<main
			style={{
				minHeight: "100vh",
				display: "grid",
				placeItems: "center",
				padding: "48px 16px 64px",
				background:
					"radial-gradient(circle at top, rgba(99,102,241,0.22), transparent 55%), radial-gradient(circle at bottom, rgba(14,165,233,0.2), transparent 60%), #05070c",
				color: "#e7ecf8",
				fontFamily:
					"'Inter', ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial",
			}}
		>
			<section
				style={{
					width: "100%",
					maxWidth: 720,
					background: "rgba(9, 14, 22, 0.85)",
					border: "1px solid rgba(148, 163, 184, 0.25)",
					boxShadow: "0 25px 60px rgba(15, 23, 42, 0.45)",
					borderRadius: 24,
					padding: "32px 36px",
					display: "grid",
					gap: 28,
				}}
			>
				<header style={{ display: "grid", gap: 16 }}>
					<span
						style={{
							textTransform: "uppercase",
							letterSpacing: "0.18em",
							fontSize: 12,
							color: "#38bdf8",
							fontWeight: 600,
						}}
					>
						InstaLaw Platform
					</span>
					<h1
						style={{
							margin: 0,
							fontSize: 44,
							fontWeight: 700,
							letterSpacing: "-0.03em",
						}}
					>
						Launch a public intake form in minutes
					</h1>
					<p style={{ margin: 0, maxWidth: 520, color: "#aab7cd", lineHeight: 1.6 }}>
						This app hosts your client-facing forms. Provision a tenant, hand out the link, and InstLaw handles
						theme, file uploads, and secure delivery to your attorneys.
					</p>
				</header>

				<section style={{ display: "grid", gap: 18 }}>
					<div
						style={{
							display: "grid",
							gap: 6,
							background: "rgba(15, 23, 42, 0.6)",
							borderRadius: 16,
							padding: "18px 22px",
							border: "1px solid rgba(148, 163, 184, 0.2)",
						}}
					>
						<h2 style={{ margin: 0, fontSize: 20, fontWeight: 600 }}>Try a live form</h2>
						<p style={{ margin: 0, color: "#94a3b8" }}>
							Everything in the tenant namespace is live. This sample form is safe to explore.
						</p>
						<Link
							to="/forms/$org/$slug"
							params={{ org: "hallattorneys", slug: "ftx-intake" }}
							style={{
								display: "inline-flex",
								alignItems: "center",
								gap: 6,
								padding: "10px 16px",
								borderRadius: 999,
								border: "1px solid rgba(56, 189, 248, 0.4)",
								color: "#38bdf8",
								fontWeight: 600,
								textDecoration: "none",
							}}
						>
							<span>hallattorneys / ftx-intake</span>
							<span aria-hidden="true">→</span>
						</Link>
					</div>

					<div style={{ display: "grid", gap: 10 }}>
						<h2 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>Jump to other tools</h2>
						<div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
							{QUICK_LINKS.map((app) => (
								<a
									key={app.label}
									href={app.href}
									target="_blank"
									rel="noopener noreferrer"
									style={{
										display: "inline-flex",
										alignItems: "center",
										gap: 8,
										padding: "10px 16px",
										borderRadius: 10,
										border: "1px solid rgba(148, 163, 184, 0.25)",
										background: "rgba(15, 23, 42, 0.55)",
										color: "#e7ecf8",
										textDecoration: "none",
										fontWeight: 600,
									}}
								>
									<span>{app.label}</span>
									<span aria-hidden="true" style={{ opacity: 0.7 }}>
										↗
									</span>
								</a>
							))}
						</div>
					</div>
				</section>
			</section>
		</main>
	);
}
